import SlimSelect from "slim-select";

const customSelect = () => {
    const customSelects = document.querySelectorAll('.select-js');

    const slimSelectInstances = [];

    if (customSelects.length) {
        Array.from(customSelects).forEach((selectEl) => {
            if (!selectEl) return;

            const instance = new SlimSelect({
                select: selectEl,
                showSearch: false,
                showContent: "auto",
            });

            slimSelectInstances.push(instance);
        });
    }

    function clearSelects() {
        slimSelectInstances.forEach((instance) => {
            try {
                instance.set(instance.config.isMultiple ? [] : '');
            } catch (error) {
                console.error("Ошибка очистки селекта:", error);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', customSelect);
